import React, { useEffect, useState, useRef } from 'react';
export function StickyOrderButton() {
  const [isVisible, setIsVisible] = useState(false);
  const triggerRef = useRef<HTMLElement | null>(null);
  useEffect(() => {
    // Find the trigger text "Not slower. Faster."
    const findTriggerElement = () => {
      const allElements = document.querySelectorAll('p, span, div');
      for (const el of allElements) {
        if (el.textContent?.includes('Not slower. Faster.')) {
          triggerRef.current = el as HTMLElement;
          break;
        }
      }
    };
    // Wait a bit for DOM to be ready
    setTimeout(findTriggerElement, 500);
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        // Show button when trigger element is above viewport
        setIsVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, {
      threshold: 0,
      rootMargin: '-100px 0px 0px 0px'
    });
    if (triggerRef.current) {
      observer.observe(triggerRef.current);
    }
    return () => {
      observer.disconnect();
    };
  }, []);
  const handleClick = () => {
    const ctaSection = document.getElementById('call-to-action-section');
    if (ctaSection) {
      ctaSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 pointer-events-none" data-id="element-563">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 pb-4 sm:pb-6 pointer-events-auto" data-id="element-564">
        <button onClick={handleClick} className="w-full bg-gradient-to-r from-teal-500 to-blue-500 hover:from-teal-600 hover:to-blue-600 text-white font-bold py-4 px-6 rounded-full transition-all duration-300 shadow-2xl hover:shadow-3xl transform hover:-translate-y-1 text-base sm:text-lg pulse-animation flex items-center justify-center gap-2" aria-label="Order Now - Scroll to purchase section" data-id="element-565">
          <span data-id="element-566">Order Now</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="animate-bounce" data-id="element-567">
            <path d="M12 5v14M19 12l-7 7-7-7" data-id="element-568" />
          </svg>
        </button>
      </div>
    </div>;
}